<template>
  <div id="report_user">
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <div class="form-inline">
          <label class="mr-sm-2" for="datepickerInput">Date : </label>
          <datepicker
            :input-class="'form-control'"
            :value="currentDate"
            v-on:selected="onDateChange"
            style="display: inline-block"
          ></datepicker>
          <a href="javascript:void(0);" class="btn btn-outline-primary ml-1" @click="getList()">
            <em class="fa fa-refresh" />
          </a>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 text-right">
        <!-- Rounded switch -->
        <span for="autoRefreshInput" style="vertical-align: top; line-height: 2.2em"
          >Auto Refresh</span
        >
        <label class="switch">
          <input type="checkbox" :checked="isAutoRefresh" @change="enableAutoUpdate()" />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
    <br />
    <table class="table table-bordered table-hover">
      <thead>
        <tr class="text-center">
          <th scope="col" width="100">Time</th>
          <th scope="col" width="170">District</th>
          <th scope="col" width="170">Priority</th>
          <th scope="col">Message</th>
          <th scope="col" width="170">Report By</th>
          <th scope="col" width="200">Action</th>
        </tr>
      </thead>
      <tbody>
        <reporter-list-item
          v-for="(report, index) in reporterlist"
          :key="index"
          :problemid="report.id"
          :report="report"
          :pageid="pageid"
          @onDelete="deleteReport($event)"
        ></reporter-list-item>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'

import config from '@/config'

import reporterItemList from './reporter-list-item'

export default {
  data: function () {
    return {
      reporterlist: [],
      currentDate: '',
      timer: '',
      isAutoRefresh: true,
      maxTime: 300000
    }
  },
  components: {
    'reporter-list-item': reporterItemList,
    datepicker: datepicker
  },
  created: function () {
    this.currentDate = new Date()
    this.getList()
    this.timer = setInterval(this.getList, this.maxTime)
  },
  computed: {
    pageid() {
      return this.$store.state.selectedBot.pageid
    }
  },
  methods: {
    onDateChange: function (date) {
      this.currentDate = new Date(date)
      this.getList()
    },
    getList: function () {
      let vm = this
      vm.$store.dispatch('loading')
      axios.defaults.headers.common = {
        AUTHORIZATION: this.$store.getters.securityToken
      }
      axios
        .get(
          config.serverUrl +
            'problemreport?type=user&date=' +
            moment(this.currentDate).format('YYYY-MM-DD') +
            '&pageid=' +
            this.pageid
        )
        .then((response) => {
          // JSON responses are automatically parsed.
          var response = response.data
          if (response.responsecode == 200) {
            this.reporterlist = response.data
            // console.log()
          } else if (response.responsecode == 400) {
            let message = response.reason ? response.reason : ''
            var isFacebook = vm.$store.state.isFacebook
            vm.$store.dispatch('logout', {
              error: { code: response.responsecode, message: message }
            })
            if (
              vm.$router.history.current.name != 'login' ||
              vm.$router.history.current.name != 'nigol'
            ) {
              if (isFacebook) {
                vm.$router.push('/login')
              } else {
                vm.$router.push('/nigol')
              }
            }
          } else {
          }
          vm.$store.dispatch('loading')
        })
        .catch((e) => {
          console.error(e)
          // this.errors.push(e)
          vm.$store.dispatch('loading')
        })
    },
    deleteReport: function (payload) {
      let vm = this
      const reportIndex = vm.reporterlist.findIndex((report) => {
        return report.id == payload
      })
      vm.reporterlist = vm.reporterlist.splice(reportIndex, 1)
    },
    enableAutoUpdate: function () {
      this.isAutoRefresh = !this.isAutoRefresh
      if (this.isAutoRefresh) {
        this.timer = setInterval(this.getList, this.maxTime)
      } else {
        clearInterval(this.timer)
      }
    }
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  }
}
</script>

<style>
/* The switch - the box around the slider
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox *
.switch input {display:none;}

/* The slider *
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders *
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}  */
</style>



// WEBPACK FOOTER //
// src/components/view/template/oishineko/reporter-user.vue